import {saveAs} from 'file-saver'
import {collection, doc, getDocs, getFirestore} from 'firebase/firestore'
import {useAuth} from '../../../../modules/auth'
import ExcelJS from 'exceljs'
import {useState} from 'react'
import AddAsset from '../AddAsset'
import AddAssetCSV from '../AddAssetCSV'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import ExportButton from 'app/components/ExportButton'
import Button from 'app/components/Button'
import { format } from 'date-fns'

const AssetListToolbar = ({currentAuditContext}: {currentAuditContext: any}) => {
  const {currentUser} = useAuth()
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isCSV, setIsCSV] = useState(false)

  const exportData = async () => {
    const db = getFirestore()
    const tenantId = currentUser?.tenantId
    const tenantRef = doc(db, 'tenants', tenantId!)
    const PolicyRef = collection(tenantRef, 'assets')
    const querySnapshot = await getDocs(PolicyRef)

    const data = querySnapshot.docs.map((doc) => doc.data()).filter((doc) => !doc.is_repo)

    if (data.length > 0) {
      const fields = [
        {key: 'serial_number', header: 'Serial Number', width: 20},
        {key: 'name', header: 'Name', width: 15},
        {key: 'model', header: 'Model', width: 15},
        {key: 'os_version', header: 'OS Version', width: 20},
        {key: 'owner', header: 'Owner', width: 20},
        {key: 'hd_encryption', header: 'HD Encryption', width: 15},
        {key: 'anti_virus', header: 'Anti Virus', width: 15},
        {key: 'password_policy', header: 'Password Policy', width: 15},
        {key: 'screen_policy', header: 'Screen Policy', width: 15},
        {key: 'firewall', header: 'Firewall', width: 15},
        {key: 'audit_scope', header: 'Audit Scope', width: 15},
        {key: 'last_checkedin',header: 'Created At',width: 15},
      ]

      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Assets')

      worksheet.columns = fields.map((field) => ({
        header: field.header,
        key: field.key,
        width: field.width,
      }))

      const headerRow = worksheet.getRow(1)
      headerRow.font = {bold: true, color: {argb: 'FFFFFFFF'}, size: 10}
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: 'FF000000'},
      }
      headerRow.height = 30
      headerRow.alignment = {horizontal: 'center'}

      worksheet.views = [{state: 'frozen', ySplit: 1}]

      for (let i = 1; i <= fields.length; i++) {
        const cell = headerRow.getCell(i)
        cell.font = {bold: true, color: {argb: 'FFFFFFFF'}, size: 11}
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'FF000000'},
        }
        cell.alignment = {horizontal: 'center', vertical: 'middle'}
      }

      data.forEach((row) => {
        const rowData = fields.reduce((acc, field) => {
          let value = row[field.key] || row[field.key.toLowerCase()] || ''

          if (field.key === 'last_checkedin' && value) {
            const date = new Date(value)
            acc[field.key] = format(date,'yyyy-MM-dd')
          } else {
            acc[field.key] = value
          }

          return acc
        }, {})

        const addedRow = worksheet.addRow(rowData)
        addedRow.height = 20
        addedRow.font = {size: 11}

        fields.forEach((field) => {
          const cell = addedRow.getCell(field.key)
          if (
            [
              'anti_virus',
              'audit_scope',
              'firewall',
              'hd_encryption',
              'password_policy',
              'screen_policy',
            ].includes(field.key)
          ) {
            if (cell.value === 'No') {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {argb: 'F4CCCC'},
              }
            } else if (cell.value === 'Yes') {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {argb: 'D9EAD3'},
              }
            }
          }
        })
      })

      const buffer = await workbook.xlsx.writeBuffer()
      const excelBlob = new Blob([buffer], {type: 'application/octet-stream'})
      saveAs(excelBlob, 'Assets.xlsx')
      showSuccessToast({message: 'Assets data exported successfully'})
    } else {
      if (typeof showSuccessToast === 'function') {
        showErrorToast({message: 'No data to export'})
      } 
      return
    }
  }

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible)
  }

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleCloseModal2 = () => {
    setIsCSV(!isCSV)
  }

  const handleOpenModal2 = () => {
    setIsCSV(true)
  }

  return (
    <>
      <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {currentUser?.role !== 'Auditor' && !currentAuditContext && (
        <ExportButton className='me-4' onClick={exportData} />
      )}
        {currentUser?.role !== 'Auditor' && !currentAuditContext && (
          <div className='dropdown'>
            <Button
              btnType='primary'
              onClick={toggleDropdown}
              id='dropdownMenu2'
              data-bs-toggle='dropdown'
              aria-haspopup='true'
              aria-expanded='false'
            >
              <span className='mx-2'>Add Assets</span>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-chevron-down rotate-180'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M6 9l6 6l6 -6' />
              </svg>
            </Button>
            <ul
              className='dropdown-menu mt-2'
              aria-labelledby='dropdownMenu2'
              style={{width: '160px'}}
            >
              <li>
                <button
                  className='dropdown-item text-hover-primary button-with-icon'
                  type='button'
                  onClick={handleOpenModal}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#5A5A5A'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-pencil mb-1 mx-1 '
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4' />
                    <path d='M13.5 6.5l4 4' />
                  </svg>{' '}
                  Add manually
                </button>
              </li>

              <li>
                <button
                  className='dropdown-item text-hover-primary button-with-icon'
                  type='button'
                  onClick={handleOpenModal2}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#5A5A5A'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-file-import mb-1 mx-1'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M14 3v4a1 1 0 0 0 1 1h4' />
                    <path d='M5 13v-8a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5.5m-9.5 -2h7m-3 -3l3 3l-3 3' />
                  </svg>{' '}
                  Import
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
      <AddAssetCSV isOpen={isCSV} onClose={handleCloseModal2} />
      <AddAsset isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  )
}

export {AssetListToolbar}
